export class TopNavItem {
    public name: string;
    public route: string;
    public string: string;
    public access?: boolean;
    public icon?: string;
    public subnav: TopNavItem[];

    constructor(item?: TopNavItem) {
        this.name = item && item.name ? item.name : '';
        this.route = item && item.route ? item.route : '';
        this.string = item && item.string ? item.string : '';
        this.access = item && item.access ? item.access : false;
        this.icon = item && item.icon ? item.icon : '';
        this.subnav = item && item.subnav ? item.subnav : [];
    }
}
